import { ReCAPTCHAProps } from 'react-google-recaptcha';

import { LocalePrefix } from '@tmh-website/shared/const';

/**
 * Resolves the value for the `hl` prop/param of the Google reCAPTCHA.
 *
 * @param locale - The `LocalePrefix` that is to be mapped to the `hl` param value.
 *
 * @returns - `string`, if the provided `locale` has its corresponding `hl` value, otherwise `undefined`.
 *
 * @see https://developers.google.com/recaptcha/docs/display#javascript_resource_apijs_parameters
 * @see https://developers.google.com/recaptcha/docs/language
 */
export const getCaptchaHlBasedOnLocale = (locale: LocalePrefix): ReCAPTCHAProps['hl'] => {
  switch (locale) {
    case LocalePrefix.De:
      return 'de';
    case LocalePrefix.DeCH:
      return 'de-CH';
    case LocalePrefix.En:
      return 'en-GB';
    case LocalePrefix.EnUS:
      return 'en';
    case LocalePrefix.Fr:
    case LocalePrefix.FrCH:
      return 'fr';
    default:
      return undefined;
  }
};
